// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__18Q8l","gfeWrapper":"CalendarEvent_gfeWrapper__I4maB"};